import { z } from 'zod'

export const DeviceSchema = z.object({
  device_id: z.number(),
  serial_number: z.string(),
  status_id: z.number(),
  create_date: z.string(),
  update_date: z.string(),
  site_id: z.number(),
  handshake_date: z.string().nullable(),
})

export const SiteDeviceSchema = z.object({
  created_at: z.string().optional(),
  id: z.number().or(z.string()).transform(v => String(v)),
  serial_number: z.string(),
  site_id: z.number().optional(),
  name: z.string(),
  status: z.string().optional().default('offline').transform(v => v === 'Unknown' ? 'offline' : v),
  updated_at: z.string().optional(),
})

export const UserSchema = z.object({
  player_id: z.number(),
  email: z.string(),
  display_name: z.string(),
  host_site_id: z.number(),
  host_site_name: z.string(),
  devices: z.array(DeviceSchema),
})

export const AppSchema = z.object({
  icon_url: z.string(),
  id: z.number(),
  spectator_url: z.string(),
  status: z.string(),
  sort_order: z.number(),
  created_at: z.string(),
  label: z.string(),
  app_url: z.string(),
  name: z.string(),
  game_id_type: z.string().nullable(),
  params: z.any().nullable(),
  is_default: z.boolean(),
  updated_at: z.string(),
  disabled: z.boolean(),
  disabled_reason: z.string(),
})

export const DeviceStatusMessageSchema = z.object({
  type: z
    .literal("device_status")
    .or(z.literal("ping").or(z.literal("command_response"))),
  serial_number: z.string(),
  status: z.string(),
});

export type User = z.infer<typeof UserSchema>
export type Device = z.infer<typeof DeviceSchema>
export type SiteDevice = z.infer<typeof SiteDeviceSchema>
export type App = z.infer<typeof AppSchema>
export type DeviceStatusMessage = z.infer<typeof DeviceStatusMessageSchema>
